import { Link } from 'react-router-dom'
import RoleBadge from '../RoleBadge'
import { PROFILE_OVERVIEW, USERS } from '../../mockData'
import { userDetailPath, WIREFRAME_PATHS } from '../../routes'

// Users with access to this profile: the profile's team members plus org-wide admins.
const assignedUsers = USERS.filter(
    (u) => u.allTeams || u.teams.includes(PROFILE_OVERVIEW.teamName)
)

export default function UsersTab() {
    return (
        <div className="rounded-lg border border-gray-200 bg-white">
            <div className="flex items-center border-b border-gray-100 px-4 py-2.5">
                <span className="text-[13px] font-semibold text-gray-900">Users with access</span>
                <span className="ml-2 text-xs text-gray-800">{assignedUsers.length}</span>
            </div>
            <table className="w-full border-collapse text-sm">
                <tbody className="divide-y divide-gray-50">
                    {assignedUsers.map((u) => (
                        <tr key={u.id}>
                            <td className="px-4 py-2.5">
                                <Link
                                    to={userDetailPath(u.id)}
                                    className="font-medium text-arwen-700 hover:underline"
                                >
                                    {u.name}
                                </Link>
                                <div className="text-[11.5px] text-gray-800">{u.email}</div>
                            </td>
                            <td className="px-4 py-2.5">
                                <RoleBadge role={u.role} />
                            </td>
                            <td className="px-4 py-2.5 text-right text-xs text-gray-800">
                                {u.allTeams ? 'Org admin · all teams' : 'via team'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="border-t border-gray-100 px-4 py-2.5 text-[11.5px] text-gray-800">
                Access is inherited from the profile's team. Manage members on the{' '}
                <Link to={WIREFRAME_PATHS.orgUsers} className="text-arwen-700 hover:underline">
                    Users &amp; access
                </Link>{' '}
                tab.
            </div>
        </div>
    )
}
